import { useAuth0 } from "@auth0/auth0-react";
import SignupWizard from "components/Signup/SignupWizard";
import { Button, ButtonColor, ButtonFill } from "components/Button";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";

function Signup() {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const { account, currently_selected_organization } = useContext(
    OrgRolesAndAccountContext
  );
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (account && !currently_selected_organization) {
      setStep(2);
    }
    if (account && currently_selected_organization) {
      setStep(3);
    }
  }, [account, currently_selected_organization]);

  return (
    <div className="flex flex-col items-center justify-center h-[70vh]">
      <Helmet>
        <title>Sign Up</title>
      </Helmet>

      {!isAuthenticated ? (
        <Button
          color={ButtonColor.GREEN}
          fill={ButtonFill.HOLLOW}
          onClick={() => {
            loginWithRedirect({
              authorizationParams: {
                screen_hint: "signup",
                redirect_uri: `${process.env.REACT_APP_FRONTEND_DOMAIN}/signup`,
              },
            });
          }}
        >
          Sign Up
        </Button>
      ) : (
        <SignupWizard step={step} setStep={setStep} />
      )}
    </div>
  );
}

export default Signup;
